import { TemplateResponse } from "@accurx/api/content";

import { allTemplatesString, noCategoryString } from "./CategoriesFilter";

export const getDistinctCategories = (
    templates: TemplateResponse[],
): string[] => {
    const categories = templates.map((template) => template.category);
    return Array.from(new Set(categories));
};

export function templateCategoryMatchesSelectedCategory(
    templateCategory: string,
    selectedCategory: string,
) {
    const categoryFilter =
        selectedCategory === noCategoryString ? "" : selectedCategory;

    return templateCategory === categoryFilter;
}

export function filterByCategory(
    templates: TemplateResponse[],
    selectedCategory: string,
) {
    if (selectedCategory === allTemplatesString) {
        return templates;
    }

    return templates.filter((template) =>
        templateCategoryMatchesSelectedCategory(
            template.category,
            selectedCategory,
        ),
    );
}
